<div class="k-overlay" *ngIf="editFormActive"></div>
<kendo-window *ngIf="editFormActive" (close)="closeEditForm()" [width]="1200" [height]="605" style="position:fixed"
    [top]="60" (stateChange)="onWindowStateChange($event)">
    <kendo-window-titlebar>
        <div class="k-window-title">
            <h3 class="ellipsis-text">{{ (isNew ? 'ADD-REPORT' : 'EDIT-REPORT') | translate }}<span *ngIf="!isNew"
                    class="montserrat"> - {{name.value}}</span>
            </h3>
        </div>
        <button kendoWindowMaximizeAction></button>
        <button kendoWindowRestoreAction></button>
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <form novalidate [formGroup]="editForm">
        <kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)">
            <kendo-tabstrip-tab title="{{ 'REPORT' | translate }}" [selected]="true">
                <ng-template kendoTabContent>
                    <div class="k-form tab-program">
                        <div class="row">
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'NAME' | translate}} *
                                    </span>
                                    <input id="name" kendoTextBox formControlName="name" maxlength="100"
                                        class="k-textbox" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="name.hasError('required') && name.touched">
                                        {{'REQUIRED-NAME' | translate}}
                                    </div>
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'TYPE' | translate}} *
                                    </span>
                                    <div>
                                        <span>
                                            <input type="radio" value="METRIC" name="reportType"
                                                formControlName="reportType" id="radioMetric" kendoRadioButton />
                                            <label class="k-radio-label" for="radioMetric">{{'REPORT-TYPE-METRIC' |
                                                translate}}
                                            </label>
                                        </span>
                                        <span>
                                            <input type="radio" value="REPORT" name="reportType"
                                                formControlName="reportType" id="radioReport" kendoRadioButton />
                                            <label class="k-radio-label" for="radioReport">{{'REPORT-TYPE-REPORT' |
                                                translate}}
                                            </label>
                                        </span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-5">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'REPORT-VIEW' | translate}} *
                                    </span>
                                    <span style="display: inline-flex">
                                        <div kendoTooltip position="top" class="keyboard-accessible" tabindex="0"
                                            showOn="none" (focus)="showTooltip(reportTooltip)" aria-live="polite"
                                            (mouseover)="showTooltip(reportTooltip)" (blur)="hideTooltip()"
                                            (mouseout)="hideTooltip()">
                                            <a #reportTooltip title="{{'INFO-REPORT-VIEW' | translate}}"><i
                                                    class="fa fa-info-circle pointer"></i>
                                            </a>
                                        </div>
                                    </span>
                                    <kendo-combobox id="sqlViewName" formControlName="sqlViewName" class="w-100"
                                        [data]="extracts" (valueChange)="viewChanged($event)" [valueField]="'value'"
                                        [textField]="'text'" [valuePrimitive]="true">
                                    </kendo-combobox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="sqlViewName.hasError('required') && sqlViewName.touched">
                                        {{'REQUIRED-REPORT-VIEW' | translate}}
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row" style="min-height: 297px;">
                            <div class="col-6">
                                <label for="description" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'DESCRIPTION' | translate }} *
                                    </span>
                                    <textarea id="description" kendoTextArea class="w-100 k-textarea" rows="3"
                                        formControlName="description" maxlength="4000" style="max-height: 262px;">
                                    </textarea>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="description.hasError('required') && description.touched">
                                        {{'REQUIRED-DESCRIPTION' | translate}}
                                    </div>
                                </label>
                            </div>
                            <div class="col-1">
                                <div class="row" style="min-height: 176px">
                                    <div class="col-12" style="margin-top: 3px">
                                        <label class="k-text-uppercase dark mr-2 pt-2 w-100" for="privateReport">
                                            {{ 'PRIVATE' | translate }}
                                        </label>
                                        <kendo-switch formControlName="privateReport" onLabel="{{'YES' | translate }}"
                                            offLabel="{{'NO' | translate }}">
                                        </kendo-switch>
                                    </div>
                                </div>
                            </div>
                            <div class="col-5" *ngIf="privateReport.value">
                                <span class="k-text-uppercase dark k-form-field">{{'STAFF' | translate}}</span>
                                <kendo-grid [data]="view.gridData" [hideHeader]="true" [navigable]="true"
                                    (cancel)="staffCancelHandler($event)" [pageable]="false"
                                    (save)="staffSaveHandler($event)" (add)="staffAddHandler($event)"
                                    (dataStateChange)="dataStateChange($event)" style="max-height:190px">
                                    <kendo-grid-messages noRecords="{{ 'NO-STAFF' | translate }}">
                                    </kendo-grid-messages>
                                    <kendo-grid-column field="name" [width]="70">
                                        <ng-template kendoGridEditTemplate>
                                            <kendo-combobox id="staffDropdown" [data]="staffCandidatesFiltered"
                                                [textField]="'name'" [valueField]="'id'" [filterable]="true"
                                                (filterChange)="filterStaffCandidates($event)" (close)="searchTerm=''"
                                                [(value)]="newStaffMember" [itemDisabled]="itemDisabled">
                                                <ng-template kendoComboBoxItemTemplate let-dataItem>
                                                    <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                                                    </span>
                                                </ng-template>
                                            </kendo-combobox>
                                        </ng-template>
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            <span
                                                [ngClass]="{'disabled-record-text': !dataItem.enabled || dataItem.deleted,
                                                                                    'k-text-line-through': dataItem.deleted}">{{dataItem.name}}</span>&nbsp;<span
                                                class="disabled-record-text">{{setRecordStateText(dataItem)}}</span>
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-command-column [width]="30" class="text-center">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            <ng-container *ngIf="!dataItem.editing">
                                                <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}"
                                                    (click)="deleteStaff(dataItem)"></i>
                                            </ng-container>
                                            <ng-container *ngIf="dataItem.editing">
                                                <ng-container
                                                    *ngIf="newStaffMember !== null && newStaffMember !== undefined">
                                                    <i class="fas fa-check fa-lg icon-success pointer"
                                                        title="{{'SAVE' | translate}}"
                                                        (click)="staffSaveButton.click.emit($event); dataItem.editing = false;">
                                                    </i>
                                                    &nbsp;
                                                </ng-container>
                                                <i class="fas fa-times-circle fa-lg icon-neutral pointer"
                                                    title="{{'CANCEL' | translate}}"
                                                    (click)="staffCancelButton.click.emit($event); dataItem.editing = false;"></i>
                                                <button kendoGridSaveCommand #staffSaveButton class="d-none"></button>
                                                <button kendoGridCancelCommand #staffCancelButton
                                                    class="d-none"></button>
                                            </ng-container>
                                        </ng-template>
                                    </kendo-grid-command-column>
                                    <button kendoGridAddCommand #staffAddButton class="d-none"></button>
                                </kendo-grid>
                                <button kendoButton [primary]="false" type="button" class="float-right mt-3"
                                    (click)="staffAddButton.click.emit($event)">
                                    {{'ADD' | translate}}<i class="far fa-user-plus"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'FORM-DESIGN' | translate }}" [disabled]="!sqlViewName.value">
                <ng-template kendoTabContent>
                    <app-report-grid *ngIf="editForm" [reportId]="reportEdit.id" [sqlViewName]="sqlViewName.value"
                        [gridSettings]="gridSettings" [editForm]="editForm" [reportName]="name.value"
                        (addFunctionEvent)="addFunctionEvent($event)"
                        (removeFunctionEvent)="removeFunctionEvent($event)"
                        (gridSettingsChanged)="gridSettingsChanged($event)" [designMode]="true"
                        [parentWindowState]="windowState">
                    </app-report-grid>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
    </form>
    <kendo-dialog-actions style="position:absolute;margin-left:-16px" class="w-100 mt-3">
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button *ngIf="selectedTab === 1" appPreventClick class="k-button k-primary"
            [disabled]="!editForm.valid || !editForm.dirty" (click)="onSave($event,true)">{{
            'APPLY' | translate }}
        </button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
            (click)="onSave($event,false)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-window>